import {Injectable} from '@angular/core'
import {EnviromentIds} from '@common/global-constants'
import {UVEApiService} from './api.service'

/**
 * Variante del `UVEApiService` para modo embebido.
 *
 * @description
 * Extiende `UVEApiService` ajustando el `timeout` a 90 s (frente a 15 s estándar) y
 * sobrescribiendo los headers UVE: fija `X-AppId=street-embedded` y omite la cabecera
 * `Authorization`, ya que la autenticación la gestiona la app anfitriona. Se inyecta
 * automáticamente cuando la app detecta que corre dentro de un contenedor embebido.
 *
 * @usageNotes
 *
 * ### Best Practices
 * - No instanciar manualmente: el contenedor de DI elige entre `UVEApiService` y este
 *   según el bootstrap (modo standalone vs. embebido).
 *
 * ### Bad Uses / Errores comunes
 * - Inyectar esta clase desde servicios de dominio rompe el desacoplamiento: usar
 *   `UVEApiService` y dejar que DI seleccione la implementación adecuada.
 */
@Injectable({providedIn: 'root'})
export class UVEApiEmbeddedService extends UVEApiService {
  constructor() {
    super()
    this.expirationTime = 90000
  }

  protected getUveHeaders = () => {
    const options = this.getBasicOptions()
    options.headers = options.headers
      .append('X-Uve-Platform', this.platform() ?? 'sfa')
      .append('X-Slot', '')
      .append('X-AppId', 'street-embedded')
      .append('X-Uve-Version', this.environmentService.getEnvironmentData(EnviromentIds.VERSION))
    return options
  }
}
